import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;

  & > .title {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 0.875rem;
    font-weight: 600;
    padding-bottom: 0.75rem;
  }

  & > .subtitle {
    width: 100%;
    font-size: 0.875rem;
    font-weight: 400;
    display: flex;
    margin-right: 1rem;
    padding-bottom: 0.75rem;
  }
`;
